"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinTheMovement() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section data-section-id="231749" id="join-the-movement" ref={sectionRef} className="bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden">
      <style>{`
        @keyframes pulseBorder {
          0%, 100% {
            box-shadow: 0 0 0 0 hsla(320, 100%, 60%, 0.7), 0 0 24px 4px hsla(190, 100%, 50%, 0.3);
            border-color: var(--secondary);
          }
          50% {
            box-shadow: 0 0 0 8px hsla(320, 100%, 60%, 0), 0 0 48px 12px hsla(190, 100%, 50%, 0.5);
            border-color: var(--primary);
          }
        }
        .pulse-border-btn {
          animation: pulseBorder 2.4s ease-in-out infinite;
        }
        @keyframes floatShape {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-18px) rotate(4deg); }
          66% { transform: translateY(-8px) rotate(-3deg); }
        }
        .float-shape {
          animation: floatShape 7s ease-in-out infinite;
        }
        @keyframes orbPulse {
          0%, 100% { opacity: 0.6; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.08); }
        }
        .orb-pulse {
          animation: orbPulse 4s ease-in-out infinite;
        }
      `}</style>

      <div className="max-w-7xl mx-auto">
        <div className={`relative bg-card rounded-2xl shadow-4xl overflow-visible transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
        border: "1px solid var(--border)",
        boxShadow: "inset 0 0 60px -20px var(--primary)"
      }}>
          {}
          <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
          background: "radial-gradient(ellipse at 30% 50%, hsla(190,100%,50%,0.08) 0%, transparent 65%), radial-gradient(ellipse at 70% 50%, hsla(320,100%,60%,0.06) 0%, transparent 65%)"
        }} />

          <div className="flex flex-col lg:flex-row items-stretch min-h-[380px] relative z-10">
            {}
            <div className="flex flex-col justify-center gap-6 lg:w-[60%] p-8 md:p-12 lg:p-16">
              {}
              <div className="flex items-center gap-2">
                <Sparkles className="size-4" style={{
                color: "var(--secondary)"
              }} />
                <span className="text-xs font-default font-semibold uppercase tracking-widest" style={{
                color: "var(--muted-foreground)"
              }}>
                  Artist Submissions Open
                </span>
              </div>

              {}
              <h2 className="font-default text-5xl md:text-7xl font-black leading-tight tracking-wider" style={{
              background: "linear-gradient(135deg, var(--foreground) 0%, var(--secondary) 55%, var(--primary) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text"
            }}>READY TO Soar Above The Horizon?</h2>

              {}
              <p className="font-default text-base md:text-lg leading-relaxed max-w-md font-light" style={{
              color: "var(--muted-foreground)"
            }}>
                Join the Michigan collective pushing the boundaries of EDM, Pop, and Rock. Your sound deserves a horizon without limits.
              </p>

              {}
              <ul className="flex flex-col gap-2">
                {["Global Distribution", "Personal Support", "Grow with us"].map((feature, i) => <li key={feature} data-index={i} className="flex items-center gap-2 text-sm font-default" style={{
                color: "var(--muted-foreground)"
              }}><span className="size-1.5 rounded-lg shrink-0" style={{
                  background: 'var(--secondary)'
                }}></span>{feature}</li>)}
              </ul>

              {}
              <div className="mt-2">
                <Button asChild size="lg" className="pulse-border-btn relative text-base font-default font-bold px-10 py-7 rounded-lg border-2 transition-all duration-300 hover:scale-105" style={{
                background: "linear-gradient(135deg, var(--secondary), var(--primary))",
                color: "var(--secondary-foreground)",
                borderColor: "var(--secondary)"
              }}>
                  <Link to="/SubmissionsPage">
                    SUBMIT DEMO
                    <ArrowRight className="size-5 ml-1" />
                  </Link>
                </Button>
              </div>
            </div>

            {}
            <div className="relative lg:w-[40%] flex items-center justify-center py-8 lg:py-0 overflow-visible">
              {}
              <div className="float-shape relative z-20" style={{
              marginTop: "-60px",
              marginBottom: "-60px"
            }}>
                {}
                <div className="orb-pulse absolute inset-0 rounded-lg blur-3xl pointer-events-none" style={{
                background: "radial-gradient(circle, hsla(320,100%,60%,0.35) 0%, hsla(190,100%,50%,0.18) 60%, transparent 100%)",
                transform: "scale(1.4)"
              }} />

                {}
                <img src="https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Submit-a-demo.png" className="relative z-10 drop-shadow-2xl" />
              </div>
            </div>
          </div>

          {}
          <div className="absolute bottom-0 left-8 right-8 h-px rounded-lg opacity-40" style={{
          background: "linear-gradient(90deg, transparent, var(--primary), var(--secondary), transparent)"
        }} />
        </div>
      </div>
    </section>;
}